import { ChangeDetectionStrategy, Component, computed, input, output, signal, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SpherePluginPermissionService } from '@sphere/platform';
import { AppRoute, AppRouteData, SphereAppCategoryListItem } from '@sphere/platform';
import { MatCard, MatCardAvatar, MatCardHeader, MatCardSubtitle, MatCardTitle } from '@angular/material/card';
import { NgClass, NgStyle, UpperCasePipe } from '@angular/common';
import { MatRipple } from '@angular/material/core';
import { RouterLink } from '@angular/router';
import { ExperimentalTagComponent } from '@sphere/platform';

import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { SPHERE_HOME_PAGE_PATH } from '../../../sphere-app.routes';
import { FunctionWrapperPipe } from '@sphere/platform';

@Component({
    selector: 'sphere-home-app-card',
    templateUrl: './home-app-card.component.html',
    styleUrls: ['./home-app-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatCard,
        MatCardSubtitle,
        MatCardTitle,
        NgClass,
        NgStyle,
        MatRipple,
        RouterLink,
        MatCardHeader,
        ExperimentalTagComponent,
        UpperCasePipe,
        FunctionWrapperPipe,
        MatCardAvatar,
        MatIconButton,
        MatIcon,
        MatTooltip
    ]
})
export class HomeAppCardComponent {
    private sanitizer = inject(DomSanitizer);
    private sphereApps = inject(SpherePluginPermissionService);

    public readonly homePagePath = SPHERE_HOME_PAGE_PATH;

    public readonly mode = input<'category' | 'app'>('app');

    /**
     * When mode is 'category'
     */
    public readonly category = input<SphereAppCategoryListItem>();

    /**
     * When mode is 'app'
     */
    public readonly favoriteApp = input<boolean>(false);
    public readonly app = input<AppRoute>();
    public readonly disabled = computed(() => {
        if (this.mode() !== 'app' || !this.app()) {
            return false; // App permissions are only checked when in 'app' mode.
        }
        return !this.sphereApps.hasAppPermission(this.app());
    });
    public readonly disableFavoriteToggle = input<boolean>(false);

    toggleFavorite = output();

    public readonly cardHover = signal<boolean>(false);

    public readonly appData = computed(() => {
        return this.app()?.data || ({} as AppRouteData);
    });

    public readonly appLogo = computed(() => {
        if (!this.appData().logoSvg) {
            return null;
        }
        return this.sanitizer.bypassSecurityTrustStyle(`url("${this.appData().logoSvg}")`);
    });

    public readonly categoryLogo = computed(() => {
        if (!this.category().logoSvg) {
            return null;
        }
        return this.sanitizer.bypassSecurityTrustStyle(`url("${this.category().logoSvg}")`);
    });

    sanitizeHTML = (html: string): SafeHtml => {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    };

    _toggleFavorite(event: MouseEvent) {
        event.stopPropagation();
        this.toggleFavorite.emit();
    }
}
